import LlSwitch from "@/components/LlSwitch.vue";
import axios from "axios";
import { useCustomFieldStore } from "./useCustomFieldStore.js";
import LlCheckbox from "@/components/LlCheckbox.vue";
import LlTooltip from "@/components/LlTooltip.vue";
import DeleteCustomFieldsModal from "./DeleteCustomFieldsModal.vue";
import LlRadioGroup from '@/components/LlRadioGroup.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import { ref } from "vue";
export default {
  props: {
    alerts: {
      type: Object,
      required: true
    },
    customField: {
      type: Object,
      required: false
    }
  },
  name: "UpdateCustomField",
  components: {
    DeleteCustomFieldsModal,
    LlCheckbox,
    LlRadioGroup,
    LlSwitch,
    LlTooltip,
    LlSecondaryButton,
    LlSelect
  },
  setup(props, {
    emit
  }) {
    const customFieldStore = useCustomFieldStore();
    customFieldStore.alerts = props.alerts;
    const field = ref({
      customFieldName: "Custom",
      type: "text",
      name: "",
      active: true,
      entity: "Client",
      showOnInvoice: false
    });
    const customFieldTypeOptions = ref([{
      label: "Text",
      value: "text"
    }, {
      label: "Number",
      value: "number"
    }, {
      label: "Date",
      value: "date"
    }, {
      label: "Checkbox",
      value: "checkbox"
    }]);
    const customFieldClientMatterOptions = ref([{
      label: "Client",
      value: "Client"
    }, {
      label: "Matter",
      value: "Matter"
    }]);
    if (props.customField.id) {
      const {
        id,
        type,
        name,
        active,
        entity,
        showOnInvoice,
        showOnClient,
        showOnMatter
      } = props.customField;
      field.value.id = id;
      field.value.name = name;
      field.value.active = active;
      field.value.entity = entity;
      field.value.type = type?.toLowerCase();
      field.value.showOnInvoice = showOnInvoice, field.value.showOnClient = showOnClient, field.value.showOnMatter = showOnMatter;
      field.value.customFieldName = "Custom";
    }
    const save = () => {
      if (field.value.name.length < 2) {
        props.alerts.error("Field names must be at least 2 characters in length");
        return;
      }
      if (field.value.id) {
        updateCustomField(field.value);
      } else {
        customFieldStore.createCustomField(field.value);
      }
    };
    async function updateCustomField(customField) {
      try {
        await axios({
          url: `/customFields/${customField.id}`,
          method: "PUT",
          data: customField
        });
        props.alerts.success("Custom Field Updated Successfully");
        close(true);
      } catch (error) {
        props.alerts.error(error.response.data.message);
      }
    }
    const close = reload => {
      customFieldStore.showUpdateCustomFieldModal = false;
      customFieldStore.showDeleteCustomFieldsModal = false;
      if (reload) {
        emit("filter");
      }
    };
    async function deleteCF(customFieldId) {
      try {
        await axios({
          url: `/customFields/${customFieldId}`,
          method: "DELETE"
        });
        props.alerts.success("Custom Field Deleted Successfully");
        close(true);
      } catch (error) {
        props.alerts.error(error);
      }
    }
    const showDeleteModal = () => {
      customFieldStore.toggleDeleteCustomFieldsModal(field.value);
    };
    return {
      save,
      deleteCF,
      close,
      field,
      showDeleteModal,
      customFieldStore,
      customFieldTypeOptions,
      customFieldClientMatterOptions
    };
  }
};